import React from "react"

import Avatar from "../../../../design-system/avatar"
import LinkWithArrowDeprecated from "../../../../design-system/link-with-arrow-deprecated"
import ParagraphDeprecated from "../../../../design-system/paragraph-deprecated"
import SubtitleDeprecated from "../../../../design-system/subtitle-deprecated"
import Blockquote from "../../../../shared-components/blockquote"
import { CmsArticleContent } from "../../../../shared-components/cms-article-content"
import { CaseStudyPageContext } from "../../types"
import * as styles from "./index.module.scss"

type Props = CaseStudyPageContext

function CaseStudyArticle({
  body,
  authorAvatar,
  authorName,
  authorTitle,
  startQuote,
  endQuote,
  suggestedReadingUrl,
  suggestedReadingTitle,
}: Props) {
  return (
    <div className={styles.container}>
      <div className={styles.quoteContainer}>
        {authorAvatar?.url && (
          <Avatar url={authorAvatar?.url} name={authorName} variant="large" />
        )}
        {startQuote && (
          <ParagraphDeprecated variant="2">{startQuote}</ParagraphDeprecated>
        )}
      </div>
      <CmsArticleContent body={body} />
      <Blockquote
        className={styles.endQuote}
        quote={endQuote}
        authorName={authorName}
        authorTitle={authorTitle}
      />
      {suggestedReadingTitle && suggestedReadingUrl && (
        <div>
          <SubtitleDeprecated variant="h2" className={styles.bold}>
            Read:
          </SubtitleDeprecated>
          <LinkWithArrowDeprecated
            variant="xLarge"
            to={suggestedReadingUrl}
            text={suggestedReadingTitle}
          />
        </div>
      )}
    </div>
  )
}

export default CaseStudyArticle
